import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'jalali-moment';

import JalaliDatePicker from '../JalaliDatePicker/JalaliDatePicker.component';

const todayGregorian = () => moment().format('YYYY-MM-DD');

const JalaliDateRange = ({
	fromFieldKey = 'from_date',
	toFieldKey = 'to_date',
	fromValue = null,
	toValue = null,
	yearsBack = 10
}) => {
	const { t } = useTranslation();
	const [fromDate, setFromDate] = useState(fromValue || null);
	const [toDate, setToDate] = useState(toValue || null);
	const today = todayGregorian();

	useEffect(() => {
		setFromDate(fromValue || null);
	}, [fromValue]);

	useEffect(() => {
		setToDate(toValue || null);
	}, [toValue]);

	const handleFromChange = nextFrom => {
		setFromDate(nextFrom);
		if (nextFrom && toDate && nextFrom > toDate)
			setToDate(null);
	};

	const handleToChange = nextTo => {
		if (nextTo && fromDate && fromDate > nextTo)
			return;
		setToDate(nextTo);
	};

	const fromMaxDate = [toDate, today].filter(Boolean).sort()[0];

	return (
		<>
			<JalaliDatePicker
				fieldKey={fromFieldKey}
				title={t('from_date')}
				value={fromDate}
				maxDate={fromMaxDate}
				yearsBack={yearsBack}
				onChange={handleFromChange}
			/>
			<JalaliDatePicker
				fieldKey={toFieldKey}
				title={t('to_date')}
				value={toDate}
				minDate={fromDate}
				maxDate={today}
				yearsBack={yearsBack}
				onChange={handleToChange}
			/>
		</>
	);
};

export default JalaliDateRange;
